/**
 * Created by tpowell on 10/2/16.
 */

var NewJersey = (function() {
  function nj_delegate_adjust_buttons() {
    if ($('#user_professional_license_type').val() === 'cma') {
      $('#delegateAlertButton').prop('disabled', true);
      $('#nj_delegate_acknowledgment').prop('disabled', false);
      $('#nj_delegate_acknowledgment').show();
    } else {
      $('#delegateAlertButton').prop('disabled', false);
      $('#nj_delegate_acknowledgment').prop('disabled', true);
      $('#nj_delegate_acknowledgment').hide();
    }
  }

  // called dynamically from nj_delegate_acknowledgment
  function nj_delegate_registration_hooks() {
    nj_delegate_adjust_buttons();
    $('#user_professional_license_type').on('change', function () {
      nj_delegate_adjust_buttons();
    });
    $('#acknowledged').on('change', function() {
      if($('#acknowledged').is(':checked')) {
        $('#delegateAlertButton').prop('disabled', false);
      }
    });
  }

  function nj_update_supervisor_continue_button() {
    if($('#acknowledged').is(':checked')) {
      $('#supervisorContinueButton').prop('disabled', false);
    } else {
      $('#supervisorContinueButton').prop('disabled', true);
    }
  }

  function nj_supervisor_hooks() {
    // Mark approve buttons for NJ-specific handling and remove generic class
    // so the delegates.js handler does not also fire on these buttons
    $('.approve-delegate-button, [class*="approve-delegate-button-"]').each(function() {
      var $btn = $(this);
      $btn.attr('data-nj-approve', 'true');
      // Store the confirm URL from the href before we neutralize UJS
      if (!$btn.data('confirmUrl') && $btn.attr('href') && $btn.attr('href') !== '#') {
        $btn.data('confirmUrl', $btn.attr('href'));
      }
      // Remove UJS data attributes so Rails doesn't auto-fire the request
      $btn.removeAttr('data-method').removeAttr('data-remote').attr('href', '#');
      // Remove the generic class so delegates.js handler is not triggered
      // Keep the ID-specific class (approve-delegate-button-{id}) for other code
      $btn.removeClass('approve-delegate-button');
    });

    $(document).on('click', '[data-nj-approve]', function(e) {
      e.preventDefault();
      var $button = $(this);
      var target = $button.data('confirmUrl') || $button.attr('href');

      $('#nj_supervisor_acknowledgment_modal').modal('show');
      nj_update_supervisor_continue_button();
      $('#supervisorContinueButton').off('click').on('click', function() {
        var liabilityModal = $('#liability-confirmation-modal');
        var njModal = $('#nj_supervisor_acknowledgment_modal');
        njModal.modal('hide');
        if (liabilityModal.length) {
          liabilityModal.find('.confirmation-button').attr('href', target);
          njModal.one('hidden.bs.modal', function() {
            liabilityModal.modal('show');
          });
        } else {
          $.ajax({
            type: 'PATCH',
            url: target,
            data: '',
            dataType: 'script'
          });
        }
      });
      return false;
    });
    $('#acknowledged').on('change', function() {
      nj_update_supervisor_continue_button();
    });
  }
  return {
    delegate_registration_hooks: nj_delegate_registration_hooks,
    supervisor_hooks: nj_supervisor_hooks
  };
})();

window.NewJersey = NewJersey;
